import { FunctionComponent, createContext, useContext, useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import { TriggerJourney } from './TriggerJourney.types';
import { fetchWorkflowsTriggeredByOtherWorkflowsQuery } from './TriggerJourney.queries';

type TriggerJourneysContextState = {
  loadTriggerJourneys?: () => void;
  triggerJourneys: TriggerJourney[];
  called: boolean;
  error?: any;
  loading: boolean;
  refetch: any;
};

const TriggerJourneyContext = createContext<TriggerJourneysContextState>({
  loadTriggerJourneys: () => {},
  triggerJourneys: [],
  called: false,
  error: null,
  loading: false,
  refetch: undefined,
});

export const TriggerJourneyContextProvider: FunctionComponent<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [loadTriggerJourneys, { data, called, error, loading, refetch }] = useLazyQuery(
    fetchWorkflowsTriggeredByOtherWorkflowsQuery,
    {
      fetchPolicy: 'no-cache',
    },
  );

  useEffect(() => {
    loadTriggerJourneys();
  }, []);

  const context: TriggerJourneysContextState = {
    loadTriggerJourneys,
    triggerJourneys:
      ((data as any)?.workflowsTriggeredByOtherWorkflows?.results as TriggerJourney[]) ||
      ([] as TriggerJourney[]),
    called,
    error,
    loading,
    refetch,
  };
  return (
    <TriggerJourneyContext.Provider value={context}>{children}</TriggerJourneyContext.Provider>
  );
};

export const useTriggeredJourneyContext = () => useContext(TriggerJourneyContext);
